import { useNavigate } from 'react-router-dom';
import {
  selectFromHDToEdgeReturnPath,
  setFromHDToEdgeReturnPath,
  updateNavigationFromOnboarding,
} from '../store/slices/onboardingSlice';
import { useAppDispatch, useAppSelector } from '../store/hooks';
import { useSolutionOrg } from '../config/useSolutionOrg';
import { getDashboardEntryRoute } from './dashboardEntryRoute';
import { resolveHomeDepotSetupReturnPath } from './homeDepotEnrollmentIntent';

export function useBackToEdgeFromHomeDepot() {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { isNativeAppExperience, solutionOrgName } = useSolutionOrg();
  const fromHDToEdgeReturnPath = useAppSelector(selectFromHDToEdgeReturnPath);

  const backToEdgeFromHomeDepot = () => {
    // navigate to content home page
    dispatch(updateNavigationFromOnboarding(true));

    navigate(resolveHomeDepotSetupReturnPath({
      redirectPath: fromHDToEdgeReturnPath,
      fallbackPath: getDashboardEntryRoute(solutionOrgName),
    }), {
      state: { fromOnboarding: true },
    });
    if (isNativeAppExperience) {
      // show optimus app
      window.parent.postMessage({
        payload: { hideOptimusApp: false },
        type: 'OPTIMUS_HIDE_REQUEST',
      }, '*');
    }
    dispatch(setFromHDToEdgeReturnPath('')); // reset path
  };

  return backToEdgeFromHomeDepot;
}
